import React, { useState } from 'react';

import IconButton from '@mui/material/IconButton';

import { Tracklog } from 'ff/debrief/models';
import LogbookIcon from '../customIcons/LogbookIcon';
import LogbookSelectionModal from 'ff/debrief/components/logbookAssociation/LogbookSelectionModal';

type Props = Pick<Tracklog, 'logbookAssociationDetails'> & {
    selected: boolean;
    logbookId: string | null;
};

const TracklogLogbookIcon: React.FC<Props> = props => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleClick = () => {
        if (props.logbookAssociationDetails.length > 1) {
            setIsModalOpen(true);
        } else {
            window.open(
                `/logbook#/entries?entryId=${props.logbookAssociationDetails[0].logbookEntryID}`,
                '_blank'
            );
        }
    };

    const handleLogbookSelect = (logbookId: string) => {
        window.open(`/logbook#/entries?entryId=${logbookId}`, '_blank');
        setIsModalOpen(false);
    };

    return (
        <>
            <IconButton onClick={handleClick}>
                <LogbookIcon
                    sx={{
                        color: props.selected
                            ? 'rgb(255, 255, 255)'
                            : '#697D90',
                        fontSize: '20px',
                        transition: 'color 0.1s ease',
                    }}
                    viewBox="0 0 15 12"
                />
            </IconButton>

            <LogbookSelectionModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSelect={handleLogbookSelect}
            />
        </>
    );
};

export default TracklogLogbookIcon;
